module.exports = __webpack_public_path__ + "media/spa/sp_recommended_job_offers_banner-4dc9c994.svg";